package fi.bullpen.kmpapp.data.turnkey.dto

import kotlinx.serialization.Serializable

@Serializable
data class GetUserQuery(
    override val organizationId: String, val userId: String,
) : TurnkeyQueryRequestBody()